const UserInfo = () => import('./UserInfo.vue')
const User = () => import('./User.vue')
const MemberRights = () => import('./MemberRights.vue')
const UpdateUserInfo = () => import('./UpdateUserInfo.vue')
const UpdatePhone = () => import('./phone/UpdatePhone.vue')

export {
  UserInfo,
  User,
  MemberRights,
  UpdateUserInfo,
  UpdatePhone
}



// WEBPACK FOOTER //
// ./src/pages/user/index.js